export async function requestNotificationPermission(userId, role, supabase) {
  if (!('Notification' in window)) {
    console.warn('This browser does not support desktop notification');
    return;
  }
  
  if (Notification.permission === 'granted') {
    await subscribeUserToPush(userId, role, supabase);
  } else if (Notification.permission !== 'denied') {
    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      await subscribeUserToPush(userId, role, supabase);
    }
  }
}

async function subscribeUserToPush(userId, role, supabase) {
  if (!('serviceWorker' in navigator)) return;

  try {
    const registration = await navigator.serviceWorker.ready;
    
    // Check if already subscribed
    const existingSubscription = await registration.pushManager.getSubscription();
    if (existingSubscription) {
      await saveSubscriptionToSupabase(existingSubscription, userId, role, supabase);
      return;
    }

    // Replace with your VAPID public key
    const vapidPublicKey = 'BEl62iUYgUivxIkv69yViEuiBIa-Ib9-SkvMeAtA3LFgDzkrxZJjSgSnfckjBJuBkr3qBUYIHBQFLXYp5Nksh8U'; 
    const convertedVapidKey = urlBase64ToUint8Array(vapidPublicKey);

    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: convertedVapidKey
    });

    await saveSubscriptionToSupabase(subscription, userId, role, supabase);
  } catch (error) {
    console.error('Failed to subscribe to push notifications:', error);
  }
}

async function saveSubscriptionToSupabase(subscription, userId, role, supabase) {
  try {
    const pushToken = JSON.stringify(subscription);
    // Asumiendo que la tabla profiles tiene la columna push_token
    await supabase.from('profiles').update({ push_token: pushToken }).eq('id', userId);
  } catch (error) {
    console.error('Error saving push token to Supabase:', error);
  }
}

// Utility function to convert VAPID key
function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
    .replace(/-/g, '+')
    .replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export async function sendPushNotification(studentName, title, message, supabase) {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    const token = session?.access_token;
    if (!token) return;

    // Use Edge Function URL (adjust project ref accordingly, assuming SUPABASE_URL exists on window or we pass it)
    // Actually, we can use supabase.functions.invoke
    const { error } = await supabase.functions.invoke('send-push', {
      body: { studentName, title, message }
    });
    
    if (error) {
      console.error('Error invoking push edge function:', error);
    }
  } catch (err) {
    console.error('Failed to trigger push notification:', err);
  }
}
